module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAYAAAC5UQwxAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAErSURBVHgBtdbRDYIwEAbgOyZwFB3BCYzPvLiBOoE4gSPwAnO4Am7CBnhnijbQ0rty/gkpkHJfCqUpAKWu6w38MX59bJrmgog3OuebVVmWdzCMX38YhmtBF2eHcaq2bW9gFK5F9R9jfYYL+GFgiboalX+PwJ7BPR29JRrC2KBXekTXYUvNEwKj1X7TGEbHnmp16HVcjaYwvsDJA9moBJuBuagUC4JaVINFQSmqxRbBFDppRVgSTKCgxUSgEBVhYlCA7iQYpwB5DhAf4QGEkb7S0GycRrQiSSZNbOpz1CtS6reI/mfuXL0MYg42TpCcZRBzMa+vCsU1WA6KazEtihaYBkUrTIqiJZZCP/tSak+WGMc9O9sNhvalq7El9LsvpaG+qO2ssCk61ud96Ru5BwLbzznIfwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/close.png
// module id = ip1C
// module chunks = 0